import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 
import LazyLoad from 'react-lazy-load'

import Shopify from '../../shopify'
import ProductPreview from './product-preview'

// import searchIcon from '../../images/search.svg'
import arrowIcon from '../../images/ARROW-F.svg'
// import bookCover from '../../images/books-featured.svg'

class OnlineStorePage extends Component {

    componentDidMount() {
        Shopify.createComponent('product', {
            id: [this.props.promotedProduct.product.shopifyProduct],
            node: document.getElementById('promoted-product'),
            options: {
                "cart": {
                    "popup": false,
                    "text": { "currency": "EUR" },
                    "styles": {
                        "button": { "background-color": "red" }
                    }
                },
                "product": {
                    "iframe": false,
                    "templates": {
                        "button": '<div class="button small secondary w-inline-block" data-element="product.buttonWrapper"><button style="background: none;" {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="text-block-3" data-element="product.button">{{data.buttonText}}</button><img alt="" src=' + arrowIcon + ' style="margin-left: 12px" width="10px" data-w-id="5aa351f4-adf5-6966-206d-069186f7cf15" class="image-59" /></div>'
                    },
                    "text": {
                        "button": "Add to Basket",
                    },
                    "contents": {
                        "img": false,
                        "imgWithCarousel": false,
                        "title": false,
                        "variantTitle": false,
                        "price": false,
                        "description": false,
                        "buttonWithQuantity": false,
                        "quantity": false,
                        "footer": false,
                    },
                    "classes": {
                        "wrapper": 'button small secondary w-inline-block',
                        "button": 'text-block-3',
                    },
                },
            }
        })
    }

    render() {
        const rowCount = Math.ceil((this.props.products.length / 2) / 4.0)
        const seo = this.props.seo, generic = this.props.social.generic[0], twitter = this.props.social.twitter[0];
        const { routeResolver } = this.props.context

        var blockLazy = (/blocklazy/gi).test(window.location.href);

        var structuredDataProducts = []
        //Comment
        const rendered_products = this.props.productsSlugs.map(p => ({
            ...p,
            link: 'https://startupguide.com/' + routeResolver.product.get(p.slug),
        }))

        // console.log('DEBUG')
        // console.log(rendered_products)

        for (var i in rendered_products) {
            structuredDataProducts.push({
                "@type": "Book",
                "name": rendered_products[i].name,
                "position": (parseInt(i, 10) + 1),
                "url": rendered_products[i].link
            })
        }

        return (
            <div>
                <Helmet>
                    <title>Startup Guide - {seo.title ? seo.title : "Books"}</title>
                    <meta content={seo.description ? seo.description : this.props.description} name="description" />

                    <meta content="website" property="og:type" />
                    <meta content={generic && generic.title ? generic.title : this.props.title} property="og:title" />
                    <meta content={generic && generic.description ? generic.description : this.props.description} property="og:description" />
                    <meta content={generic && generic.image ? generic.image : this.props.picture} property="og:image" />
                    <meta property="og:url" content="https://startupguide.com/shop"></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={twitter && twitter.type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={twitter && twitter.handle ? twitter.handle : '@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={twitter && twitter.title ? twitter.title : this.props.title}></meta>
                    <meta name="twitter:description" content={twitter && twitter.description ? twitter.description : this.props.description}></meta>
                    <meta name="twitter:image" content={twitter && twitter.image ? twitter.image : this.props.picture}></meta>
                    <script type="application/ld+json">{`
                        {
                          "@context":"https://schema.org",
                          "@type":"ItemList",
                          "itemListElement": `+ JSON.stringify(structuredDataProducts) + `
                        }
                    `}</script>
                </Helmet>
                <div className="page-title-stores" style={{ height: 'fit-content' }}>
                    <img src={this.props.picture} style={{ opacity: '0', width: '100%' }} alt=""/>
                    <div style={{
                        width: '100%',
                        display: 'block',
                        height: '100%',
                        backgroundImage: 'url(\'' + this.props.picture + '\'',
                        position: 'absolute',
                        top: 0,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                    />

                    <div className="description">
                        <div className="text-block-65">{this.props.title}</div>
                        <p className="paragraph smal">{this.props.description}</p>
                    </div>
                </div>
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="all-books">
                            <div className="books_buy">
                                {Array(rowCount).fill().map((_, rowIndex) =>
                                    <div key={rowIndex} className="books w-row">
                                        {this.props.products.slice(rowIndex * 4, 4 + rowIndex * 4).map((p, k) =>
                                            <ProductPreview
                                                key={k}
                                                noMargin={(k % 4) === 0}
                                                context={this.props.context}
                                                product={p}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </LazyLoad>
                }
                {blockLazy &&
                    <div className="all-books">
                        <div className="books_buy">
                            {Array(rowCount).fill().map((_, rowIndex) =>
                                <div key={rowIndex} className="books w-row">
                                    {this.props.products.slice(rowIndex * 4, 4 + rowIndex * 4).map((p, k) =>
                                        <ProductPreview
                                            key={k}
                                            noMargin={(k % 4) === 0}
                                            context={this.props.context}
                                            product={p}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                }

                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="new-books" style={{ 'background-color': this.props.promotedProduct.color }}>
                            <div className="new-book">
                                <div className="row-4 w-row">
                                    <div className="w-col w-col-6">
                                        <img alt="" src={this.props.promotedProduct.product.picture} width={466} className="image-61" />
                                    </div>
                                    <div className="column-6 w-col w-col-6">
                                        <div className="div-block-65">
                                            <img alt="" src={this.props.promotedProduct.headerPicture} width={280} className="image-58" />
                                            <p className="paragraph-normal" style={{ 'color': this.props.promotedProduct.textColor }}>{this.props.promotedProduct.description}</p>
                                            <div className="buttons-container w-clearfix">
                                                <Link to={this.props.promotedProduct.link} className="explore-the-book w-button" style={{ 'color': this.props.promotedProduct.textColor }}>
                                                    {this.props.promotedProduct.callToAction}
                                                </Link>
                                                <div id="promoted-product"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </LazyLoad>
                }
                {blockLazy &&
                    <div className="new-books" style={{ 'background-color': this.props.promotedProduct.color }}>
                        <div className="new-book">
                            <div className="row-4 w-row">
                                <div className="w-col w-col-6">
                                    <img alt="" src={this.props.promotedProduct.product.picture} width={466} className="image-61" />
                                </div>
                                <div className="column-6 w-col w-col-6">
                                    <div className="div-block-65">
                                        <img alt="" src={this.props.promotedProduct.headerPicture} width={280} className="image-58" />
                                        <p className="paragraph-normal" style={{ 'color': this.props.promotedProduct.textColor }}>{this.props.promotedProduct.description}</p>
                                        <div className="buttons-container w-clearfix">
                                            <Link to={this.props.promotedProduct.link} className="explore-the-book w-button" style={{ 'color': this.props.promotedProduct.textColor }}>
                                                {this.props.promotedProduct.callToAction}
                                            </Link>
                                            <div id="promoted-product"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <div className="all-books">
                            <div className="books_buy">
                                {Array(rowCount).fill().map((_, rowIndex) =>
                                    <div key={rowIndex} className="books w-row">
                                        {this.props.products.slice((rowCount + rowIndex) * 4, 4 + (rowCount + rowIndex) * 4).map((p, k) =>
                                            <ProductPreview
                                                key={k}
                                                noMargin={(k % 4) === 0}
                                                context={this.props.context}
                                                product={p}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </LazyLoad>
                }
                {blockLazy &&
                    <div className="all-books">
                        <div className="books_buy">
                            {Array(rowCount).fill().map((_, rowIndex) =>
                                <div key={rowIndex} className="books w-row">
                                    {this.props.products.slice((rowCount + rowIndex) * 4, 4 + (rowCount + rowIndex) * 4).map((p, k) =>
                                        <ProductPreview
                                            key={k}
                                            noMargin={(k % 4) === 0}
                                            context={this.props.context}
                                            product={p}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const connectRelay = OnlineStorePage => class extends Component {

    render() {
        const { routeResolver } = this.props.context
        const props = {
            context: this.props.context,
            title: this.props.onlineStore.title,
            description: this.props.onlineStore.description,
            picture: this.props.onlineStore.picture,
            promotedProduct: {
                link: routeResolver.product.get(this.props.onlineStore.promotedProduct.product.slug),
                ...this.props.onlineStore.promotedProduct
            },
            products: this.props.onlineStore.products,
            productsSlugs: this.props.onlineStore.productsSlugs,
            seo: this.props.onlineStore.seo,
            social: this.props.onlineStore.social
        }
        return <OnlineStorePage {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(OnlineStorePage),
    graphql`
        fragment onlineStorePage_onlineStore on OnlineStore {
            title
            description
            picture
            promotedProduct {
                headerPicture
                description
                callToAction
                color
                textColor
                product {
                    slug
                    picture
                    shopifyProduct
                    city {
                        slug
                        color
                    }
                }
            }
            seo {
                title
                description
            }
            social {
                twitter {
                    type
                    title
                    image
                    handle
                    description
                }
                generic {
                    title
                    image
                    description
                }
            }
            productsSlugs {
                slug
                name
            }
            products {
                ...productPreview_product
            }
        }
    `
)
